export const ICONS = {
  // Navigation
  HOME: 'home',
  home: 'home',
  viewDetails: 'visibility',
  workflows: 'workflow',
  configurations: 'settings',
  arrow_back: 'arrow_back',
  arrow_forward: 'arrow_forward',
  arrow_back_ios: 'arrow_back_ios',
  arrow_back_ios_new: 'arrow_back_ios_new',
  arrow_forward_ios: 'arrow_forward_ios',
  arrow_downward: 'arrow_downward',
  arrow_drop_down: 'arrow_drop_down',
  arrow_drop_up: 'arrow_drop_up',
  
  // Actions
  notifications: 'notifications',
  login: 'login',
  logout: 'logout',
  support: 'contact_support',
  support_agent: 'support_agent',
  menu: 'menu',
  FILTER_LIST: 'filter_list',
  filter_list: 'filter_list',
  refresh: 'refresh',
  sync: 'sync',
  
  // Common
  person: 'person',
  person_add: 'person_add',
  people: 'people',
  search: 'search',
  clear: 'clear',
  close: 'close',
  COMMENT: 'comment',
  comment: 'comment',
  insert_comment: 'insert_comment',
  edit: 'edit',
  delete: 'delete',
  delete_outline: 'delete_outline',
  add: 'add',
  add_circle: 'add_circle',
  post_add: 'post_add',
  save: 'save',
  cancel: 'cancel',
  view_list: 'view_list',
  LIST: 'list',
  list: 'list',
  HISTORY: 'history',
  history: 'history',
  domain_add: 'domain_add',
  attachment: 'attachment',
  attach_file: 'attach_file',
  folder: 'folder',
  snippet_folder: 'snippet_folder',
  ATTACHMENT: 'attachment',
  download: 'download',
  upload: 'upload',
  file_download: 'file_download',
  file_upload: 'file_upload',
  verified_user: 'verified_user',
  edit_note: 'edit_note',
  groups: 'groups',
  delete_forever: 'delete_forever',
  print: 'print',
  calendar_month: 'calendar_month',
  perm_contact_calendar: 'perm_contact_calendar',
  
  // Status & Feedback
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
  check: 'check',
  check_circle: 'check_circle',
  
  // Form & Input
  visibility: 'visibility',
  visibility_off: 'visibility_off',
  expand_more: 'expand_more',
  expand_less: 'expand_less',
  keyboard_arrow_down: 'keyboard_arrow_down',
  keyboard_arrow_up: 'keyboard_arrow_up',
  keyboard_arrow_left: 'keyboard_arrow_left',
  keyboard_arrow_right: 'keyboard_arrow_right',
  check_box: 'check_box',
  check_box_outline_blank: 'check_box_outline_blank',
  
  // Business specific
  business: 'business',
  category: 'category',
  approval: 'approval',
  pending: 'pending',
  schedule: 'schedule',
  event: 'event',
  calendar_today: 'calendar_today',
  
  // User & Role
  admin_panel_settings: 'admin_panel_settings',
  manage_accounts: 'manage_accounts',
  account_circle: 'account_circle',
  // Communication
  email: 'email',
  phone: 'phone',
  message: 'message',
  
  // Data & Analytics
  analytics: 'analytics',
  assessment: 'assessment',
  bar_chart: 'bar_chart',
  
  // System
  more_vert: 'more_vert',
  more_horiz: 'more_horiz',
  help: 'help',
  help_outline: 'help_outline',
} as const;

export type IconName = keyof typeof ICONS;